export function ConvertKilometersToMiles(kilometers: number): number {
    return kilometers / 1.60934;
}
